import { ColorEnum } from '@enum/style/color.enum';

import { SidebarStyleType } from './sidebar.style-type';

export const SidebarDarkTheme: SidebarStyleType = {
  backgroundColor: ColorEnum.Black100,
};
